<template>
  <div v-if="showCustomerModal">
    <v-dialog v-model="showCustomerModal" max-width="1200" style="overflow: hidden !important;" persistent >
      <v-card>
        <v-card-title class="pb-0">
          Cari Seçimi
          <v-spacer></v-spacer>
          <div class="col-4">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Ara"
              dense
              solo
              single-line
              hide-details
              size="small"
              class="m-1"
              filled
              rounded
          ></v-text-field>
            </div>
        </v-card-title>
        <v-card-subtitle class="">
          <v-icon size="small" color="warning">mdi-information</v-icon>
          <span> Seçim yapmadan giriş yapamazsınız</span>
        </v-card-subtitle>
        <v-card-text>
          <div class="row">
            <v-data-table
                :loading="currencyCurrentListLoading"
                :headers="currencyCurrentListHeaders"
                :items="currencyCurrentList"
                :items-per-page="perPage"
                item-key="code"
                class="elevation-1"
                hide-default-footer
                :search="search"
                :no-data-text="noCurrencyCurrentMessage"
            >
              <template v-slot:item.selection="{ item }">
                <v-checkbox
                    v-model="selectedCode"
                    @click="selectCode(item)"
                    :on-icon="'mdi-checkbox-marked'"
                    :off-icon="'mdi-checkbox-blank-outline'"
                    :true-value="item"
                    :false-value="false"
                    color="warning"
                >
                </v-checkbox>
              </template>
              <template v-slot:item.currencyType="{ item }">
                <span class="text-h5 ml-4">
                  {{ fetchCurrencyLabel(item.currencyType) }}
                  </span>
              </template>
<!--                            <template #cell(selection)="data" class="text-center">-->
<!--                              <div>-->
<!--                                <v-checkbox-->
<!--                                    style="margin-top: 14px"-->
<!--                                    dense-->
<!--                                    :on-icon="'mdi-checkbox-marked'"-->
<!--                                    :off-icon="'mdi-checkbox-blank-outline'"-->
<!--                                    :true-value="data.item"-->
<!--                                    :false-value="false"-->
<!--                                    color="warning"-->
<!--                                    v-model="selectedCode"-->
<!--                                >-->
<!--                                </v-checkbox>-->
<!--                              </div>-->
<!--                            </template>-->
            </v-data-table>
<!--            <b-table-->
<!--                :items="currencyCurrentList"-->
<!--                :fields="currencyCurrentListHeaders"-->
<!--                hover-->
<!--                responsive-->
<!--                striped-->
<!--                sort-icon-left-->
<!--                :per-page="perPage"-->
<!--                :busy="currencyCurrentListLoading"-->
<!--                show-empty-->
<!--                head-row-variant="info"-->
<!--                table-variant="white"-->
<!--            >-->
<!--              <template #empty="scope">-->
<!--                <h6 class="text-center my-5">-->
<!--                  {{ scope.loading ? "Lütfen Bekleyin" : noCurrencyCurrentMessage }}-->
<!--                </h6>-->
<!--              </template>-->
<!--              <template #cell(selection)="data" class="text-center">-->
<!--                <div>-->
<!--                  <v-checkbox-->
<!--                      style="margin-top: 14px"-->
<!--                      dense-->
<!--                      :on-icon="'mdi-checkbox-marked'"-->
<!--                      :off-icon="'mdi-checkbox-blank-outline'"-->
<!--                      :true-value="data.item"-->
<!--                      :false-value="false"-->
<!--                      color="warning"-->
<!--                      v-model="selectedCode"-->
<!--                  >-->
<!--                  </v-checkbox>-->
<!--                </div>-->
<!--              </template>-->
<!--              <template #table-busy>-->
<!--                <div class="text-center">-->
<!--                  <b-spinner-->
<!--                      variant="primary"-->
<!--                      size="lg"-->
<!--                      label="Text Centered"-->
<!--                  ></b-spinner>-->
<!--                </div>-->
<!--              </template>-->
<!--              <template #cell(currencyType)="data">-->
<!--                <div class="text-center">-->
<!--                  {{ fetchCurrencyLabel(data.item.currencyType) }}-->
<!--                </div>-->
<!--              </template>-->
<!--            </b-table>-->
          </div>
          <div class="d-flex mt-5">
            <v-spacer></v-spacer>
            <v-btn small color="success" @click="_erpCodeUpdate">Seçimi Kaydet</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import router from "@/router";
import store from "@/state/store";

export default {
  name: "CustomerDialog",
  computed: {
    store() {
      return store
    },
    ...mapState("current", ["currencyCurrentList", "currencyCurrentListLoading", "currencyCurrentListHeaders","noCurrencyCurrentMessage"]),
    ...mapState("auth", ["showCustomerModal","user"]),
    ...mapState("cart", ["current"]),
    ...mapGetters("settings", ["getCurrencyLabels","currencyCurrentProcess"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
    },
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      selectedCode: null,
      currencyString: "",
      search: "",
    };
  },
  methods: {
    ...mapActions('current', ["fetchCurrencyCurrentList","fetchSingleCurrent"]),
    ...mapActions("user",["erpCodeUpdate"]),
    ...mapMutations("cart",["setCurrent"]),
    ...mapMutations("auth",["setShowCustomerModal"]),
    async _erpCodeUpdate() {
      await this.erpCodeUpdate({
        params: {
          erpCode: this.selectedCode.code
        },
        body: {}
      }).then( async () => {
        await this._fetchSingleCurrent();
      })
    },
    async _fetchSingleCurrent() {
      if (this.user.RoleGroupId === 3 || this.user.RoleGroupId === "3") {
        let current = await this.fetchSingleCurrent({
          params: {
            currentCode: this.selectedCode.code
          }
        });
        await this.setCurrent(current);
        await router.push("/");
      }
    },
    async _fetchCurrencyCurrentList() {
      await this.fetchCurrencyCurrentList({
        params: {
        },
        body: {},
        urlSegments: [`${this.user.userInfo.trin}`],
      })
    },
    async selectCode (value) {
      this.selectedCode = value;
    },
    fetchCurrencyLabel(currencyType) {
      for (const item of this.currencyLabels) {
        if (item.id === currencyType) {
          return item.label;
        }
      }
      return '₺';
    },
  },

  mounted() {
    this._fetchCurrencyCurrentList();
  },
}
</script>

<style scoped>

</style>